export const isLocationSupportedForService = ({ service }) => {
  if (!service?.city_id) {
    return false;
  }
  const hasSomeAvailableServices = service?.services?.some(s => {
    return ['AVAILABLE', 'TIME_NOT_AVAILABLE'].includes(s?.availability_type);
  })
  return hasSomeAvailableServices;
}

function markCartServices(cart, services) {
  // Create a new array to store the marked cart items
  let markedCartServices = cart.map(cartItem => {
    // Initially mark the item as not available
    let markedItem = { ...cartItem, markedAsAvailable: false };

    // Check each service to see if the cart item exists in its extended_package_items
    services.forEach(service => {
      if (service.extended_package_items.id === cartItem.id) {
        // If found, mark the item as available
        markedItem.markedAsAvailable = true;
      }
    });

    return markedItem;
  });

  return markedCartServices;
}

export const isCartValidForSubservice = ({
  service,
  cart
}) => {
  if (cart?.services?.length === 0 && cart?.packages?.length === 0) {
    return {
      isCartValid: true,
      markedCartServices: [],
      markedCartPackages: []
    }
  }
  const markedCartPackages = cart?.packages?.map(cartItem => {
    // Initially mark the item as not available
    let markedItem = { ...cartItem, markedAsAvailable: false };

    const isAvailable = service?.extended_packages?.some(p => p.id === cartItem.id)

    return {
      ...markedItem,
      markedAsAvailable: isAvailable
    }
  })

  const markedCartServices = cart?.services?.map(cartItem => {
    // Initially mark the item as not available
    let markedItem = { ...cartItem, markedAsAvailable: false };

    const isAvailable = service?.extended_package_items?.some(p => p.id === cartItem.id)

    return {
      ...markedItem,
      markedAsAvailable: isAvailable
    }
  })

  const isCartServicesInServices = markedCartServices?.every(s => s.markedAsAvailable)
  const isCartPackagesInServices = markedCartPackages?.every(s => s.markedAsAvailable)
  const isCartValid = isCartServicesInServices && isCartPackagesInServices
  return {
    isCartValid,
    markedCartServices,
    markedCartPackages
  }
}

export const isCartValidForService = ({
  activeService,
  categories,
  cart }) => {
  if (cart?.services?.length === 0 && cart?.packages?.length === 0) {
    return {
      isCartValid: true,
      markedCartServices: [],
      markedCartPackages: []
    }
  }

  const markedCartPackages = cart?.packages?.map(cartItem => {
    // Initially mark the item as not available
    let markedItem = { ...cartItem, markedAsAvailable: false };

    let markedItemContent = {}
    let featuredAvailable = true
    categories.forEach(category => {
      category?.bookings?.forEach(booking => {
        if (booking?.featured_service?.extended_package_ids?.includes(markedItem.id)) {
          markedItemContent = booking
          if (booking?.not_available) {
            featuredAvailable = false;
          }
        }
      })
    })


    const markedFillOptionPackagesAvailable = categories.some(category => {
      return category.bookings.some(booking => {
        const isInextendedPackageFeature = booking?.featured_service?.extended_package_ids?.includes(cartItem.id)
        if (isInextendedPackageFeature) {
          return !booking?.not_available
        }
      })
    })

    let isInActiveService = false
    if (activeService) {
      if (activeService?.extended_package_ids) {
        isInActiveService = activeService?.extended_package_ids?.includes(cartItem.id)
      } else {
        if (activeService?.extended_packages?.some(p => p.id === cartItem.id)) {
          isInActiveService = true
        }
      }
    }

    let isAvailable = (markedFillOptionPackagesAvailable && featuredAvailable)
    if (activeService) {
      isAvailable = isAvailable && isInActiveService
    }
    return {
      ...markedItemContent,
      ...markedItem,
      markedAsAvailable: isAvailable,
      featuredAvailable,

    };
  })

  // const markedFillOptionPackagesAvailable

  const markedCartServices = cart?.services?.map(cartItem => {
    // Initially mark the item as not available
    let markedItem = { ...cartItem, markedAsAvailable: true };
    let markedItemContent = {}
    let featuredAvailable = true
    categories.forEach(category => {

      category?.bookings?.forEach(booking => {
        if (booking?.featured_service?.extended_package_item_ids?.includes(markedItem.id)) {
          markedItemContent = booking
          if (booking?.not_available) {
            featuredAvailable = false;
          }
        }
      })
    })

    // const markedFillOptionAvailable = categories.some(category => {
    //   return category?.bookings?.some(booking => {
    //     return booking?.fillOptions?.prefill?.serviceCategory?.extended_package_items?.some(item => {
    //       return item.id === cartItem.id
    //     }
    //     )
    //   })
    // })
    const markedFillOptionAvailable = true


    let isInActiveService = false
    if (activeService) {
      if (activeService?.extended_package_item_ids) {
        isInActiveService = activeService?.extended_package_item_ids?.includes(cartItem.id)
      } else {
        if (activeService?.extended_package_items?.some(p => p.id === cartItem.id)) {
          isInActiveService = true
        }
      }
    }

    let isAvailable = (markedFillOptionAvailable) && featuredAvailable
    if (activeService) {
      isAvailable = isAvailable && isInActiveService
    }

    return {
      ...markedItemContent,
      ...markedItem,
      markedAsAvailable: isAvailable,
      featuredAvailable,
      markedFillOptionAvailable
    };
  })


  const isCartServicesInServices = markedCartServices?.every(s => s.markedAsAvailable)

  const isCartPackagesInServices = markedCartPackages?.every(s => s.markedAsAvailable)
  const isCartValid = isCartServicesInServices && isCartPackagesInServices
  return {
    isCartValid,
    markedCartServices,
    markedCartPackages
  }
}
